import { useIsTablet } from "@/config/hooks";
import HomeDesktop from "./homeDesktop";
import HomeMobile from "./homeMobile";

export default function Home() {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const isTablet = useIsTablet();

  if (isTablet) return <HomeDesktop />;

  return <HomeMobile />;
}
